import React from "react";
import Table from "sc/ui/components/Table";
import { Panel } from "react-bootstrap";
import { connect } from "react-redux";
import {
  engineerSearchPageLoad,
  engineerSearchNeedleChanged,
} from "../../actions/engineers";
import PageTitle from "sc/ui/sites/oncall/components/PageTitle";
import { citiesLoadInProgress, enabledCities } from "../../selectors/cities";
import {
  engineerSearchInProgress,
  foundEngineers,
} from "../../selectors/engineers";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";
import DropDowWithSuggestions from "sc/ui/components/DropDowWithSuggestions";
import copy from "copy-to-clipboard";

export default connect(
  (state, ownProps) => ({
    cities: enabledCities(state),
    engineers: foundEngineers(state),
    loading: citiesLoadInProgress(state),
    searching: engineerSearchInProgress(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(engineerSearchPageLoad()),
    onCitySelectionChanged: cityId =>
      dispatch(engineerSearchNeedleChanged(cityId)),
  }),
)(
  componentWithLoadTrigger(props => {
    const columns = [
      {
        header: "Area",
        data: engineer => engineer.region,
      },
      {
        header: "Engineer",
        data: engineer => {
          if (engineer.firstName && engineer.lastName) {
            return `${engineer.firstName} ${engineer.lastName}`;
          } else {
            return <span className="alert-danger badge"> Undefined! </span>;
          }
        },
      },
      {
        header: "Phone",
        // TODO Format
        data: engineer => {
          let phoneNumbers = [
            {
              label: "Work",
              phone: engineer.workPhone,
              priority: engineer.workPhonePriority,
            },
            {
              label: "Cell",
              phone: engineer.cellPhone,
              priority: engineer.cellPhonePriority,
            },
            {
              label: "Home",
              phone: engineer.homePhone,
              priority: engineer.homePhonePriority,
            },
          ];
          phoneNumbers.sort((a, b) => a.priority - b.priority);
          return (
            <div>
              <strong>1.</strong> {phoneNumbers[0]["label"]}:{" "}
              <a href={`tel:${phoneNumbers[0]["phone"]}`}>
                {phoneNumbers[0]["phone"]}
              </a>
              <br />
              <strong>2.</strong> {phoneNumbers[1]["label"]}:{" "}
              <a href={`tel:${phoneNumbers[1]["phone"]}`}>
                {phoneNumbers[1]["phone"]}
              </a>
              <br />
              <strong>3.</strong> {phoneNumbers[2]["label"]}:{" "}
              <a href={`tel:${phoneNumbers[2]["phone"]}`}>
                {phoneNumbers[2]["phone"]}
              </a>
            </div>
          );
        },
      },
      {
        header: "Emails",
        // TODO Format
        data: rowEngineer => {
          const engineer = props.engineers.find(
            engineer => engineer.id === rowEngineer.id,
          );
          const allEmails = []
            .concat(
              engineer.emails,
              engineer.regionEmails,
              engineer.partnerEmails,
            )
            .map((email, idx) => {
              const href = `mailto:${email}`;
              return (
                <div key={idx}>
                  <a href={href}>{email}</a>
                </div>
              );
            });
          return <div>{allEmails}</div>;
        },
      },
    ];
    const actions = [
      {
        id: "email-now",
        text: " Email Now",
        className: "btn-primary",
        glyph: "glyphicon glyphicon-envelope",
        href: recordId => {
          const engineer = props.engineers.find(
            engineer => engineer.id === recordId,
          );
          const allEmails = [].concat(
            engineer.emails,
            engineer.regionEmails,
            engineer.partnerEmails,
          );
          const allEmailsFormatted = allEmails.join(";");
          return `mailto:${allEmailsFormatted}`;
        },
      },
      {
        id: "copy-emails",
        text: " Copy to clipboard",
        className: "btn-primary",
        glyph: "glyphicon glyphicon-tags",
        onClick: recordId => {
          const engineer = props.engineers.find(
            engineer => engineer.id === recordId,
          );
          const allEmails = [].concat(
            engineer.emails,
            engineer.regionEmails,
            engineer.partnerEmails,
          );
          const allEmailsFormatted = allEmails.join(";");
          copy(allEmailsFormatted);
        },
      },
    ];
    const records = props.loading
      ? []
      : props.cities.map(city => {
          return { id: city.id, name: city.name + "/" + city.state };
        });
    const dropDownLabel = props.loading
      ? "Loading Cities please wait... "
      : "Enter City Name";
    return (
      <div id="engineers-search-page">
        <PageTitle title="On-Call Engineers" />
        <Panel>
          <Panel.Body>
            <DropDowWithSuggestions
              label="Search by City Name"
              cities={records}
              placeholder={dropDownLabel}
              onSelectionChanged={props.onCitySelectionChanged}
            />
          </Panel.Body>
        </Panel>
        <Table
          data={props.searching ? [] : props.engineers}
          columns={columns}
          actions={actions}
          identityProperty="id"
          noDataMessage="No engineers found matching the search criteria"
          loading={props.searching}
          loadingMessage="Searching..."
        />
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/partner-tech/EngineersSearch.js